var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-filter-buttons"},_vm._l((_vm.filters),function(filter){return _c('div',{key:filter.value,staticClass:"filter-button",class:{
      'filter-button--active': _vm.effectiveFilter === filter.value,
      'filter-button--disabled': _vm.effectiveFilter === filter.value
    },on:{"click":function($event){return _vm.selectFilter(filter.value)}}},[_vm._v("\n    "+_vm._s(filter.label)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }